export const EARTHQUAKES_WIDGET_VIEW_OPTIONS = Object.freeze([
  Object.freeze({ value: 'map', label: 'Map' }),
  Object.freeze({ value: 'details', label: 'Details' }),
]);
